import '@babel/polyfill';
import 'top20common/node_modules/vue-svgicon/polyfill';
import '@/assets/js/polyfills/removeNodes';
import 'buefy/dist/buefy.css';

import Buefy from 'buefy';
import cssVars from 'css-vars-ponyfill';
import PortalVue from 'portal-vue';
import SvgIcon from 'top20common/components/SvgIcon';
import {browser} from 'top20common/distribution/plugins/browserDetermine';
import {context} from 'top20common/distribution/plugins/context';
import {icons} from 'top20common/distribution/plugins/dynamicallyIconsPath';
import {language} from 'top20common/distribution/plugins/language';
import PosthogModule from 'top20common/distribution/plugins/posthog';
import languageService from 'top20common/distribution/services/languages';
import cssVarsConfig from 'top20common/distribution/themes/config';
import utils from 'top20common/distribution/utils';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import GetTextPlugin from 'vue-gettext';
import VModal from 'vue-js-modal';
import MQ from 'vue-match-media';
import VueMultianalytics from 'vue-multianalytics';
import Router from 'vue-router';
import VueScrollTo from 'vue-scrollto';

import analyticsPlugin from '@/plugins/analytics';

import translations from '../../translations.json';
import App from './App';
import router from './router';
import store from './store';

cssVars({...cssVarsConfig});

Vue.config.productionTip = false;
Vue.use(Buefy);
Vue.use(Router);
Vue.use(VueCookie);
Vue.use(language);
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'English',
    zh_Hans: 'Chinese'
  },
  defaultLanguage: languageService.getCurrent(),
  translations: translations,
  silent: true
});
Vue.use(VTooltip, {disposeTimeout: 0});
Vue.use(browser);
Vue.use(icons);
Vue.use(context);
Vue.use(MQ);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 120,
  easing: 'ease',
  offset: -150,
  x: false,
  y: true
});

VueMultianalytics.addCustomModule('posthog', PosthogModule);

const gaConfig = {
  appName: `Top20Talent FE`,
  appVersion: '1.0',
  trackingId: process.env.VUE_APP_GOOGLE_ANALYTICS_B2C,
  debug: process.env.NODE_ENV !== 'production'
};

const analyticsModules = {
  ga: gaConfig,
  posthog: {}
};

Vue.use(VueMultianalytics, {modules: analyticsModules}, analyticsPlugin);

if (new Vue().$language.isChinese()) {
  require('moment/locale/zh-cn');
}

Vue.component('svg-icon', SvgIcon);
Vue.use(VModal);
Vue.use(PortalVue);

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1023px)',
    desktop: '(min-width: 1024px)',
    widescreen: '(min-width: 1088px)'
  }
});

export default app;

utils.setVueForUtils(app);

if (typeof SVGElement.prototype.blur === 'undefined') {
  // fix svg for IE11
  SVGElement.prototype.blur = function() {};
}
